import '../../style';
import './index.less';



// WEBPACK FOOTER //
// ./components/input-verify-code/style/index.tsx